"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongRunningTaskManager = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const image_button_1 = require("../../components/button/image.button");
const icon_1 = require("../../components/icon");
const icons_1 = require("../../components/icon/icons");
const mithril_component_1 = require("../../components/mithril.component");
const modal_service_1 = require("../../components/modal/modal.service");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const long_running_task_manager_service_1 = require("./long.running.task.manager.service");
const long_running_task_manager_state_1 = require("./long.running.task.manager.state");
const long_running_task_manager_style_1 = require("./long.running.task.manager.style");
(0, theme_1.addStyles)(long_running_task_manager_style_1.Style);
class LongRunningTaskManager extends mithril_component_1.IMithrilStateComponent {
    constructor() {
        super();
        /** Incremented every second while popover is open, to re-render elapsed times */
        this.tick = 0;
        this.tickInterval = null;
        this.state = new long_running_task_manager_state_1.LongRunningTaskManagerState();
        this.service = new long_running_task_manager_service_1.LongRunningTaskManagerService(this.state);
    }
    get nodes() {
        var _a;
        const departmentId = (_a = services_1.Services.Department.current) === null || _a === void 0 ? void 0 : _a.objectId;
        if (!departmentId)
            return null;
        const departmentExportTasks = this.state
            .tasksForDepartment(departmentId)
            .filter((t) => long_running_task_manager_state_1.LongRunningTaskManagerState.isExportTask(t));
        const unNotifiedCount = this.state.unNotifiedCountForDepartment(departmentId);
        const hasUnactioned = this.state.hasUnactionedForDepartment(departmentId);
        let badgeView = null;
        if (unNotifiedCount > 0) {
            badgeView = this.viewBadge(unNotifiedCount);
        }
        else if (hasUnactioned) {
            badgeView = this.viewRedDot();
        }
        return (0, mithril_1.m)('div', { className: `${long_running_task_manager_style_1.CSS.container}${this.state.isPulsing ? ` ${long_running_task_manager_style_1.CSS.pulse}` : ''}` }, [
            image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                onclick: this.togglePopover,
                title: i18n_1.T.EXPORT_MANAGER_TITLE,
                id: 'export-manager',
            }),
            badgeView,
            this.state.isPopoverOpen ? this.viewPopover(departmentExportTasks, departmentId) : null,
        ]);
    }
    togglePopover() {
        this.state.isPopoverOpen = !this.state.isPopoverOpen;
        if (this.state.isPopoverOpen) {
            this.state.isPulsing = false;
            this.state.markAllNotified();
            this.startTicking();
        }
        else {
            this.stopTicking();
        }
    }
    showPopover() {
        this.state.isPopoverOpen = true;
        this.state.isPulsing = false;
        this.state.markAllNotified();
        this.startTicking();
    }
    hidePopover() {
        this.state.isPopoverOpen = false;
        this.stopTicking();
    }
    onRemove() {
        super.onRemove();
        this.stopTicking();
    }
    startTicking() {
        if (this.tickInterval != null)
            return;
        this.tickInterval = setInterval((0, mobx_1.action)(() => {
            this.tick++;
        }), 1000);
    }
    stopTicking() {
        if (this.tickInterval != null) {
            clearInterval(this.tickInterval);
            this.tickInterval = null;
        }
    }
    viewBadge(count) {
        return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.badge }, `${count}`);
    }
    viewRedDot() {
        return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.redDot });
    }
    viewPopover(tasks, departmentId) {
        const hasClearable = this.state.hasClearableItemsForDepartment(departmentId);
        return (0, mithril_1.m)('div', {
            className: long_running_task_manager_style_1.CSS.popover,
            oncreate: (node) => services_1.Services.FocusAway.from(node.dom, this.hidePopover),
        }, [
            (0, mithril_1.m)('div', { className: long_running_task_manager_style_1.CSS.header }, [
                (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.title }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_TITLE)),
                (0, mithril_1.m)('button', {
                    className: long_running_task_manager_style_1.CSS.clearButton,
                    disabled: !hasClearable,
                    onclick: () => this.handleClear(departmentId),
                }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_CLEAR)),
            ]),
            tasks.length === 0
                ? (0, mithril_1.m)('div', { className: long_running_task_manager_style_1.CSS.empty }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_EMPTY))
                : (0, mithril_1.m)('div', { className: long_running_task_manager_style_1.CSS.table }, tasks
                    .slice(0)
                    .reverse()
                    .map((task) => this.viewExportRow(task))),
        ]);
    }
    handleClear(departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const hasUnactioned = this.state.hasUnactionedForDepartment(departmentId);
            if (hasUnactioned) {
                const result = yield modal_service_1.ModalService.open({
                    title: (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_TITLE),
                    content: (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_CLEAR_CONFIRM),
                    hasCancel: true,
                });
                if (!result.ok)
                    return;
            }
            this.state.clearCompleted(departmentId);
        });
    }
    viewExportRow(task) {
        const displayStatus = (0, long_running_task_manager_state_1.getDisplayStatus)(task);
        const isActionable = displayStatus !== 'processing';
        const showIndicator = displayStatus !== 'processing' && !task.seen;
        return (0, mithril_1.m)('div', {
            className: `${long_running_task_manager_style_1.CSS.row} ${isActionable ? long_running_task_manager_style_1.CSS.rowClickable : ''}`,
            onclick: isActionable ? () => this.handleAction(task, displayStatus) : undefined,
            key: task.taskId,
        }, [
            (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.cellIndicator }, showIndicator ? (0, mithril_1.m)('span', { className: `${long_running_task_manager_style_1.CSS.unseenDot} ${this.dotColorClass(displayStatus)}` }) : null),
            (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.cellType }, task.exportType),
            (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.cellJob }, task.jobName),
            (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.cellStatus }, this.viewStatus(task, displayStatus)),
            (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.cellAction }, this.viewActionIcon(displayStatus)),
        ]);
    }
    dotColorClass(displayStatus) {
        switch (displayStatus) {
            case 'ready':
            case 'downloaded':
                return long_running_task_manager_style_1.CSS.unseenDotComplete;
            case 'warning':
                return long_running_task_manager_style_1.CSS.unseenDotWarning;
            case 'error':
            case 'failed':
                return long_running_task_manager_style_1.CSS.unseenDotError;
            default:
                return '';
        }
    }
    viewStatus(task, displayStatus) {
        // Reference tick to ensure MobX tracks it for re-renders
        void this.tick;
        switch (displayStatus) {
            case 'processing': {
                const elapsed = this.formatElapsed(Date.now() - task.startedAt);
                return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.statusProcessing }, elapsed);
            }
            case 'ready':
                return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.statusComplete }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_STATUS_READY));
            case 'downloaded':
                return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.statusDownloaded }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_STATUS_DOWNLOADED));
            case 'warning':
                return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.statusWarning }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_STATUS_WARNING));
            case 'error':
                return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.statusError }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_STATUS_ERROR));
            case 'failed':
                return (0, mithril_1.m)('span', { className: long_running_task_manager_style_1.CSS.statusError }, (0, i18n_1.Translate)(i18n_1.T.EXPORT_MANAGER_STATUS_FAILED));
        }
    }
    viewActionIcon(displayStatus) {
        switch (displayStatus) {
            case 'processing':
                return spinner_1.Spinner.view();
            case 'ready':
            case 'downloaded':
                return icon_1.Icon.view(icons_1.MaterialIcon.FILE_DOWNLOAD, { className: long_running_task_manager_style_1.CSS.actionIcon });
            case 'warning':
                return icon_1.Icon.view(icons_1.MaterialIcon.ANNOUNCEMENT, { className: `${long_running_task_manager_style_1.CSS.actionIcon} ${long_running_task_manager_style_1.CSS.actionWarning}` });
            case 'error':
                return icon_1.Icon.view(icons_1.MaterialIcon.ANNOUNCEMENT, { className: `${long_running_task_manager_style_1.CSS.actionIcon} ${long_running_task_manager_style_1.CSS.actionError}` });
            case 'failed':
                return icon_1.Icon.view(icons_1.MaterialIcon.WARNING, { className: `${long_running_task_manager_style_1.CSS.actionIcon} ${long_running_task_manager_style_1.CSS.actionError}` });
        }
    }
    handleAction(task, displayStatus) {
        const taskUpdate = { seen: true, actioned: true };
        this.state.updateTask(task.taskId, taskUpdate);
        switch (displayStatus) {
            case 'ready':
            case 'downloaded':
                this.service.downloadTask(task.taskId);
                break;
            case 'warning':
            case 'error':
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.service.showNotificationModal(task.taskId);
                this.hidePopover();
                break;
            case 'failed':
                notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_EXPORT });
                break;
        }
    }
    formatElapsed(ms) {
        const seconds = Math.floor(ms / 1000);
        if (seconds < 60)
            return `${seconds}s`;
        const minutes = Math.floor(seconds / 60);
        return `${minutes}m ${seconds % 60}s`;
    }
}
exports.LongRunningTaskManager = LongRunningTaskManager;
tslib_1.__decorate([
    mobx_1.observable
], LongRunningTaskManager.prototype, "tick", void 0);
tslib_1.__decorate([
    mobx_1.computed
], LongRunningTaskManager.prototype, "nodes", null);
tslib_1.__decorate([
    mobx_1.action.bound
], LongRunningTaskManager.prototype, "togglePopover", null);
tslib_1.__decorate([
    mobx_1.action.bound
], LongRunningTaskManager.prototype, "showPopover", null);
tslib_1.__decorate([
    mobx_1.action.bound
], LongRunningTaskManager.prototype, "hidePopover", null);
//# sourceMappingURL=long.running.task.manager.js.map